import { motion } from 'framer-motion'

const SectionTitle = ({ title, className = '' }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, x: -30 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, margin: '-100px' }}
      transition={{ duration: 0.6 }}
      className={`flex items-center mb-8 sm:mb-12 lg:mb-16 ${className}`}
    >
      <h2 className="section-title text-3xl sm:text-4xl lg:text-6xl font-heading font-semibold text-ds-navy tracking-wide whitespace-nowrap">
        {title}
      </h2>
      <motion.div 
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="section-divider origin-left ml-4 sm:ml-6 lg:ml-8 h-2 lg:h-3 flex-grow -mr-4 sm:-mr-6 lg:-mr-12"
      />
    </motion.div>
  )
}

export default SectionTitle
